import { Breadcrumbs } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { PATH as COMPANY_VENDORS_PATH } from "~/pages/settings/company_vendors";
import { ConstructionItemSettingList } from "./ConstructionItemSettingList";

export const Page: React.FC = () => (
	<DefaultV2>
		<ClientSettingLayout>
			<Breadcrumbs
				items={[
					{
						as: Link,
						href: COMPANY_VENDORS_PATH,
						label: "提携中の施工会社一覧"
					},
					{ label: "工事単価一覧" }
				]}
			/>
			<ConstructionItemSettingList />
		</ClientSettingLayout>
	</DefaultV2>
);
